import React from 'react';
import GuaranteeIcon from '../icons/GuaranteeIcon';
import DeliveryIcon from '../icons/DeliveryIcon';
import RatingIcon from '../icons/RatingIcon';
import i18n from '../../i18n';

export const ProductExtraInfo = () => {
  const LETTERS_COUNT_IN_MONTH = 3;
  const START_WAITING_DAYS = 9;
  const WAITING_DAYS = 7;
  const monthes = ['Januarys', 'Februarys', 'Marchs', 'Aprils', 'Mays', 'Junes', 'Julys', 'Augusts', 'Septembers', 'Octobers', 'Novembers', 'Decembers'];

  const capitalize = ([firstLetter, ...restOfWord]) =>
  firstLetter.toUpperCase() + restOfWord.join('')

  const startDay = new Date(new Date().setDate(new Date().getDate() + START_WAITING_DAYS));
  const startDate = startDay.getDate();
  const startMonth = i18n.t(monthes[startDay.getMonth()]);
  const startDayMonthShort = startMonth.length > LETTERS_COUNT_IN_MONTH ? `${capitalize(startMonth.substr(0, LETTERS_COUNT_IN_MONTH))}.` : startMonth;

  const lastDay = new Date(new Date(startDay).setDate(startDay.getDate() + WAITING_DAYS));
  const lastDayDate = lastDay.getDate();
  const lastDayMonth = i18n.t(monthes[lastDay.getMonth()]);
  const lastDayMonthShort = lastDayMonth.length > LETTERS_COUNT_IN_MONTH ? `${capitalize(lastDayMonth.substr(0, LETTERS_COUNT_IN_MONTH))}.` : lastDayMonth;

  return (
    <div className="b-rit-product-page__product-extra-info">
      {/* todo Nataliia Melnikova, [11.11.20 15:31] Это будет позже , пока этот элемент скроем */}
      <div className='b-rit-product-page__product-rating'>
        <RatingIcon 
          size={24} 
          color="currentColor" 
          className='b-rit-product-page__product-rating_icon'
        />
        <div>
          Рейтинг ткани:<br/>
          <span style={{color: 'initial'}}>4.8 / 5</span>
        </div>
      </div>

      <div className='b-rit-product-page__product-guarantee'>
        <GuaranteeIcon 
          size={24} 
          color="currentColor" 
          className='b-rit-product-page__product-guarantee_icon'
        />
        <div>
          Гарантия<br/>
          посадки рубашки
        </div>
      </div>

      <div className='b-rit-product-page__delivery-date'>
        <DeliveryIcon 
          size={24} 
          color="currentColor" 
          className='b-rit-product-page__delivery-date_icon'
        />
        <div>
          Доставим:<br/>
          {startDayMonthShort} {startDate} - {startDayMonthShort !== lastDayMonthShort && lastDayMonthShort} {lastDayDate}
        </div>
      </div>
    </div>
  )
}